var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.registerHash)?[_c('landing-slider'),_c('landing-categories'),_c('landing-aboutVue'),_c('landing-features')]:_vm._e(),_c('landing-membership',{attrs:{"hashMode":_vm.registerHash}}),(!_vm.registerHash)?[_c('landing-products')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }